import Constants from 'expo-constants';

const config = Constants.expoConfig.extra;

export default {
  API_URL: config.API_URL,
  GRAPHQL_URL: config.GRAPHQL_URL,
  MEDIA_STORAGE: config.MEDIA_STORAGE,
  WHATSAPP_URL: config.WHATSAPP_URL,
  AMPLITUDE_API_KEY: config.AMPLITUDE_API_KEY,
  DYNAMICLINK_API_KEY: config.DYNAMICLINK_API_KEY,
  COUNTRY_CODE: config.COUNTRY_CODE,
  ENVIRONMENT: config.ENVIRONMENT,
  AI_SUPPORT_UI_URL: config.AI_SUPPORT_UI_URL,
  MOENGAGE_API_KEY: config.MOENGAGE_API_KEY,
  SENTRY_WEB_KEY: config.SENTRY_WEB_KEY,
  FB_API_KEY: config.FB_API_KEY,
  FB_AUTH_DOMAIN: config.FB_AUTH_DOMAIN,
  FB_PROJECT_ID: config.FB_PROJECT_ID,
  FB_STORAGE_BUCKET: config.FB_STORAGE_BUCKET,
  FB_MESSAGING_SENDER_ID: config.FB_MESSAGING_SENDER_ID,
  FB_APP_ID: config.FB_APP_ID,
  FB_MEASUREMENT_ID: config.FB_MEASUREMENT_ID,
  DOWNTIME_CHECK_URL: config.DOWNTIME_CHECK_URL,
  API_KEY: config.API_KEY,
  SESSION_TIMEOUT_MS: config.SESSION_TIMEOUT_MS,
  BASE_PATH: config.BASE_PATH,
  APP_PACKAGE: config.APP_PACKAGE,
};
